import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector, useDispatch } from 'react-redux'
import { getExam } from '../../../service/eTest'
import { useState } from 'react'
import { errorMessage } from '../../../utils/toastMessage'
import { useNavigate, Link } from "react-router-dom";



const ETest = () => {
    const [getExamm, setExamm] = useState([])
    const user = useSelector((state) => state.user)
    const navigate = useNavigate();


    const handleStartTest = async (id) => {
        var now = new Date()
        var now = toEnglishDigits(now.toLocaleString('fa-IR', {
            timeZone: 'Asia/Tehran',
        }).replaceAll(" ", ""))
        function toEnglishDigits(str) {
            var e = '۰'.charCodeAt(0);
            str = str.replace(/[۰-۹]/g, function (t) {
                return t.charCodeAt(0) - e;
            });
            return str;
        }
        var exam = getExamm.filter(e => e.id = id)[0]
        var examDeadline=exam.deadLine*1000
        // =============================================exam date
        var examDate = exam.startDate.split("-")
        var examDay = parseInt(examDate[2])
        var examMonth = parseInt(examDate[1])
        var examYear = parseInt(examDate[0])
        // =============================================exam time
        var examTime=exam.startTime.split(":")
        var hourExam = parseInt(examTime[0]) * 60 * 60 * 1000
        var minExam = parseInt(examTime[1]) * 60 * 1000
        var secExam = parseInt(examTime[2]) * 1000
        var allExam=hourExam+minExam+secExam
        var allExamDeadLine=allExam+examDeadline
        // =============================================now date
        var nowDate = now.split(",")[0].split("/")
        var nowDay = parseInt(nowDate[2])
        var nowMonth = parseInt(nowDate[1])
        var nowYear = parseInt(nowDate[0])
        // =============================================now time
        var nowTime=now.split(",")[1].split(":")
        var hourNow = parseInt(nowTime[0]) * 60 * 60 * 1000
        var minNow = parseInt(nowTime[1]) * 60 * 1000
        var secNow = parseInt(nowTime[2]) * 1000
        var allNow=hourNow+minNow+secNow

        if(examYear==nowYear && examMonth==nowMonth && examDay==nowDay){
            if(allNow>=allExam && allNow<=allExamDeadLine){
                navigate(`/testE/${user.value.username}/${exam.id}`)
            }
            else{
                errorMessage("مجاز به ورود به آزمون نیستید")
            }
        }
        else{
            errorMessage("مجاز به ورود به آزمون نیستید")
        }
    }

    const handleGetExam = async () => {
        try {
            const { status, data } = await getExam(user.value.username);
            if (status === 200) {
                setExamm(data.exam)
            }
        } catch (ex) {
        }
    }



    useEffect(() => {
        handleGetExam()
    }, [])

    return (
        <>
            <Helmet>
                <title> حساب کاربری |   آزمون های من   </title>
            </Helmet>
            <div className='header'>
                <h3>آزمون های من</h3>
            </div>

            <div className='my-ctest'>
                <div className='payment' style={{ margin: "50px 0px" }}>
                    {getExamm.map(e => (
                        <div key={e.id} style={{ textAlign: "center" }}>
                            <span>{e.title}</span>
                            <br />
                            <span>تاریخ شروع: {e.startDate} / {e.startTime}</span>
                            <br />
                            <button onClick={() => handleStartTest(e.id)}>شروع آزمون</button>
                            <hr />
                        </div>
                    ))}

                </div>
            </div>


        </>
    )
}



export default ETest